<tabbed-detail-base [tabs]="navTabs()" [(activeTabIndex)]="activeTabIndex">
  @if (displayLoadingBanner()) {
    <div loading-banner class="dialog-loading-banner">
      <span>{{ "Selfservice.IP.Waiting" | translate }}</span>
    </div>
  }

  <span heading>{{ "ServiceElement.PortInternet" | translate }}</span>

  @if (showModifyButton()) {
    <modify-ip-button
      action-button
      [subscription]="subscription()"
      [isInfrastructureDelegate]="isInfrastructureDelegate()"
      (clicked)="openSelfserviceDialog($event)"
    />
  }

  @if (activeSap(); as sap) {
    <ip-sap-panel
      tab-content
      [sap]="sap"
      [ipRoutingType]="ipRoutingType()"
      [isInfrastructureDelegate]="isInfrastructureDelegate()"
      (selfServiceOpen)="openSelfserviceDialog($event)"
    />
  }
</tabbed-detail-base>
